import i18n from "../i18n";
import * as Yup from "yup";

export const LostVehicleStickerIDCardSchema = Yup.object({
  stickerNumber: Yup.string().required(
    i18n.language === "en"
      ? "Sticker number is required."
      : "رقم الملصق مطلوب."
  ),
  copyNumber: Yup.string().required(
    i18n.language === "en" ? "Copy number is required." : "رقم النسخة مطلوب."
  ),
});
